
export const emailTypes = [
    {
        value: "ENVIO_COMUNICADO",
        label: 'Envio do Comunicado da Solicitação'
    },
    {
        value: "ENVIO_SOLICITACAO",
        label: 'Envio da Solicitação'
    },
    {
        value: "RESPOSTA_SOLICITACAO",
        label: 'Envio da Resposta da Solicitação'
    },
    {
        value: "ENVIO_RELATORIO",
        label: 'Envio do Relatório Solicitação'
    },
    {
        value: "ENVIO_PLANO_ACAO",
        label: 'Envio do Plano de Ação'
    },
    {
        value: "ENCERRAMENTO_SOLICITACAO",
        label: 'Encerramento da Solicitação'
    }
];
